import type { SerializedHardware } from '@enmon/commons/lib/tools';
import { Form, Input, Select, Space } from 'antd';
import type { VFC } from 'react';
import { FilterControlButtons } from 'components/form/FilterControlButtons';
import { hardwareCategoriesOptions } from '../../../const';
import { DEFAULT_FILTER, useHardwareListFilterWithPagination } from '../useHardwareListFilterWithPagination.ts';
import { DEFAULT_PAGINATION } from '@/hooks';

export interface HardwareListFilterState {
  search?: string;
  externalId?: SerializedHardware['external_id'];
  category?: SerializedHardware['category'][];
}

export const HardwareListFilter: VFC = () => {
  const [form] = Form.useForm<HardwareListFilterState>();

  const { filter, resetFilterState, setPaginationState, setFilterAndPaginationState } =
    useHardwareListFilterWithPagination();

  const handleReset = () => {
    form.setFieldsValue(DEFAULT_FILTER);

    resetFilterState();
    setPaginationState({
      current: 1,
    });
  };

  const onValuesChange = (values: HardwareListFilterState) => {
    if (values.category?.length === 0) {
      form.setFieldValue('category', undefined);
    }
  };

  const handleFormFinish = (values: HardwareListFilterState) => {
    setFilterAndPaginationState(
      {
        ...values,
      },
      DEFAULT_PAGINATION,
    );
  };

  const selectStyle = { minWidth: 200, width: 200 };

  return (
    <Form
      form={form}
      initialValues={filter}
      layout="inline"
      onFinish={handleFormFinish}
      onValuesChange={onValuesChange}
    >
      <Space wrap direction="vertical">
        <Space wrap direction="horizontal">
          <Form.Item label="External ID" name="externalId">
            <Input placeholder="123456" />
          </Form.Item>
          <Form.Item label="Name" name="name">
            <Input placeholder="electricity meter" />
          </Form.Item>
          <Form.Item label="Category" name="category">
            <Select
              allowClear
              showArrow
              maxTagCount="responsive"
              maxTagTextLength={20}
              mode="multiple"
              options={hardwareCategoriesOptions}
              placeholder="Select category"
              style={selectStyle}
            />
          </Form.Item>
          <FilterControlButtons onClickReset={handleReset} />
        </Space>
      </Space>
    </Form>
  );
};
